import React from 'react';

function LanguageItem({ language, onEdit, onDelete }) {
  const ratingLabels = {
    0: 'Beginner',
    1: 'Intermediate',
    2: 'Proficient',
    3: 'Fluent',
    4: 'Native',
  };

  return (
    <li key={language.id} className="experience-item">
      <div className="experience-content">
        <div>
          <strong>{language.languageName}</strong> ({ratingLabels[language.languageRating] || 'No rating'})
          <br />
        </div>
        <div className="experience-actions">
          <i className="fa fa-pencil edit-icon" title="Edit" onClick={() => onEdit(language)}></i>
          <i className="fa fa-trash delete-icon" title="Delete" onClick={() => onDelete(language)}></i>
        </div>
      </div>
    </li>
  );
}

export default LanguageItem;
